import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons/faArrowToBottom';
import { faArrowToTop } from '@fortawesome/pro-solid-svg-icons/faArrowToTop';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faReply } from '@fortawesome/pro-solid-svg-icons/faReply';
import { faRotateRight } from '@fortawesome/pro-solid-svg-icons/faRotateRight';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';

library.add(
  faArrowToBottom,
  faArrowToTop,
  faCaretDown,
  faCheckCircle,
  faCheckSquare,
  faInfoCircle,
  faQuestionCircle,
  faRotateRight,
  faStar,
  faTimesCircle,
  faUpload,
  faReply,
  faCheck,
  faTimes,
  faExclamation
);
